import type { ResourceDictionary } from "Infrastructure/Translations/ResourceDictionary";
import { Resources } from "Infrastructure/Translations/Resources";
import type { ObjPathProxy } from "ts-object-path";
import { type ObjectSchema, array, number, object, string } from "yup";

export type IncomeEntry = {
  readonly incomeName: string;
  readonly amountValue: number;
};

export type OtherIncomeFormType = {
  readonly incomes: IncomeEntry[];
};

export const otherIncomesFormSchema: (
  t: (resourcePath: ObjPathProxy<ResourceDictionary, string>, options?: any) => string,
) => ObjectSchema<OtherIncomeFormType> = (t) => {
  return object({
    incomes: array<IncomeEntry>()
      .of(
        object({
          incomeName: string().required(t(Resources.Validation.Required)),
          amountValue: number()
            .transform((value) => (Number.isNaN(value) ? undefined : value))
            .min(1, t(Resources.Validation.Number.MoreThen, { count: 0 }))
            .required(t(Resources.Validation.Required)),
        }),
      )
      .min(1, t(Resources.Validation.Required))
      .required(t(Resources.Validation.Required)),
  }).required();
};
